"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("reflect-metadata");
exports.FieldSymbol = Symbol("Field");
exports.Field = (target, fieldKey) => {
    const parentFields = Reflect.getOwnMetadata(exports.FieldSymbol, Object.getPrototypeOf(target)) || [];
    const ownFields = Reflect.getOwnMetadata(exports.FieldSymbol, target) || [];
    const fields = Array.from(new Set(parentFields.concat(ownFields)));
    if (!fields.includes(fieldKey)) {
        fields.push(fieldKey);
    }
    Reflect.defineMetadata(exports.FieldSymbol, fields, target);
};
//# sourceMappingURL=Field.js.map